import type { AdsenseInfo } from '@wix/ambassador-adsense-v1-adsense-user/types';

export const findAdUnitId = (
  originCompId: string,
  connectedAdunits?: AdsenseInfo['connectedAdunits'],
): string | null => {
  if (!connectedAdunits) {
    return null;
  }

  for (const [compId, compIdObj] of Object.entries(connectedAdunits)) {
    if (compIdObj.compId?.includes(originCompId)) {
      return compId;
    }
  }
  return null;
};
